import { Entity } from '@briebug/ngrx-auto-entity';
import { FileType, GenericFile } from '../../models/generic-file';

@Entity('InvoiceFile', { uriName: 'files' })
export class InvoiceFile extends GenericFile {
  override type?: FileType.InvoiceAttachment;
}
